<template>
  <div id="app-wrapper">
    <!-- Top bar -->
    <app-topbar></app-topbar>
    <app-banner v-if="showBanners"></app-banner>

    <!-- Update modal -->
    <b-modal
      id="modalNewVersion"
      hide-header
      hide-footer
      title="Update available"
    >
      <p>A new version is available. Do you want to reload?</p>
      <b-button
        class="mt-3"
        variant="outline-secondary"
        block
        @click="hideUpdateModal"
        >No</b-button
      >
      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="updateReloadApp"
        >Yes</b-button
      >
    </b-modal>

    <!-- View -->
    <router-view />

    <app-bottombar v-if="showBanners"></app-bottombar>
  </div>
</template>
<!-- Scripts-->
<script>
// Imports
import TopbarPartial from '@/components/TopbarPartial.vue';
import BannerPartial from '@/components/BannerPartial.vue';
import BottombarPartial from '@/components/BottombarPartial.vue';

export default {
  name: 'App',
  components: {
    'app-topbar': TopbarPartial,
    'app-banner': BannerPartial,
    'app-bottombar': BottombarPartial
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      franchise: this.$route.query.franchise
    };
  },
  computed: {
    showBanners() {
      return (
        this.$route.name.toUpperCase() != 'EXPLORE' &&
        this.$route.name.toUpperCase() != 'QRCSCANNER' &&
        this.$route.name != '/' &&
        this.$route.name != ''
      );
    },
    ignoreRoute() {
      return (
        this.$route.name.toUpperCase() == 'FRANCHISE' ||
        this.$route.name.toUpperCase() == 'TAB' ||
        this.$route.name.toUpperCase() == 'PAY' ||
        this.$route.name.toUpperCase() == 'EXPLORE' ||
        this.$route.name.toUpperCase() == 'QRCSCANNER' ||
        this.$route.name.toUpperCase() == 'COMINGSOON' ||
        this.$route.name == '/' ||
        this.$route.name == ''
      );
    }
  },
  created() {
    this.evaluateLastSession();
    this.evaluateSelectedFranchise();

    // Listen for service worker "updated" event
    document.addEventListener('swUpdated', this.onServiceWorkerUpdated, {
      once: true
    });

    // Reload the app when the service worker has finished updating
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;

      // Reload the app with the new version
      window.location.reload(true);
    });
  },
  methods: {
    onServiceWorkerUpdated(e) {
      // Save new service worker registration in local field
      this.registration = e.detail;

      // Ask if we can update
      this.showUpdateModal();
    },
    updateReloadApp() {
      // Hide the modal
      this.hideUpdateModal();

      if (!this.registration || !this.registration.waiting) {
        return;
      }

      // Clear local storage
      localStorage.clear();

      // Execute the service worker reload
      this.registration.waiting.postMessage('skipWaiting');
    },
    showUpdateModal() {
      this.$bvModal.show('modalNewVersion');
    },
    hideUpdateModal() {
      this.$bvModal.hide('modalNewVersion');
    },
    evaluateLastSession() {
      var _self = this;
      var localStorageTimeout = 4 * 60 * 60 * 1000; //4 hours in milliseconds
      var datediff = new Date() - new Date(localStorage.lastSessionDate);
      if (datediff > localStorageTimeout && !_self.ignoreRoute) {
        this.clearStorage();
        _self.$router.push('Franchise');
      } else {
        localStorage.lastSessionDate = new Date();
        _self.$lastSessionDate = localStorage.lastSessionDate;
      }
    },
    evaluateSelectedFranchise() {
      var _self = this;

      if (_self.ignoreRoute)
        return;

      if (!_self.isStringNullOrEmpty(_self.$franchiseID)) return;

      var franchiseData = null;

      if (!_self.isStringNullOrEmpty(_self.$route.query.fid)) {
        franchiseData = {
          FranchiseID: _self.$route.query.fid
        };
      } else if (!_self.isStringNullOrEmpty(_self.$route.query.franchiseID)) {
        franchiseData = {
          FranchiseID: _self.$route.query.franchiseID
        };
      } else if (_self.franchise) {
        franchiseData = {
          FranchiseName: _self.franchise
        };
      }

      if (franchiseData == null) {
        _self.$router.push('Franchise');
        return;
      }

      _self.$ooApi.orders.franchises.get
        .v1(franchiseData)
        .then(function(result) {
          _self.$franchiseID = result.data.id;
          _self.$franchiseName = result.data.name;
          _self.$franchiseUrlFriendlyOrderName =
            result.data.urlFriendlyOrderName;
          _self.$franchiseLogoUrl = result.data.franchiseLogoURL;
          _self.$franchiseBannerUrl = result.data.bannerImageURL;
          _self.$franchiseAccentColor = result.data.accentColor;
          _self.$lastSessionDate = new Date();
        });
    }
  },
  watch: {
    $route() {
      this.evaluateLastSession();
      this.evaluateSelectedFranchise();
    }
  }
};
</script>
<style>
html {
  background-color: #fff;
  font-family: Roboto;
  /* Make text non-selectable*/
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

body {
  /* Disables pull-to-refresh. */
  height: 100vh;
  overscroll-behavior-y: contain;
  overflow-x: hidden;
  font-size: 14px !important;
  font-family: Source Sans Pro, Helvetica Neue, Arial !important;
  line-height: 1.42857143 !important;
  -webkit-font-smoothing: antialiased !important;
  background: #fff !important;
}

body #app-wrapper {
  height: 100%;
  padding-top: 52px;
}

body #authform .wrapper {
  background-color: #f6f6f6;
}

* {
  -webkit-touch-callout: none; /* iOS Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}

.form-control {
  height: 34px;
  padding: 6px 12px !important;
  font-size: 14px !important;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.btn {
  display: inline-block !important;
  padding: 6px 12px !important;
  margin-bottom: 0 !important;
  font-size: 14px !important;
  font-weight: normal !important;
  line-height: 1.42857143 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: middle !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  background-image: none !important;
  border: 1px solid transparent !important;
  border-radius: 4px !important;
}

.btn-lg,
.btn-group-lg > .btn {
  padding: 10px 16px !important;
  font-size: 18px !important;
  line-height: 1.33 !important;
  border-radius: 6px !important;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 10px !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  border-radius: 3px !important;
}
.btn-xs,
.btn-group-xs > .btn {
  padding: 1px 5px !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
  border-radius: 3px !important;
}

/* GENERIC */
a,
a:hover {
  color: #000;
  text-decoration: none;
}

.a {
  color: #000;
}

.app-container {
  margin: auto;
  background-color: #fff;
  color: #000;
}

/* HEADER */
.logo {
  width: 150px;
  position: absolute;
  margin-top: 100px;
  margin-left: -75px;
}

/* BANNER */
.banner-container {
  position: relative;
  text-align: center;
}

/* QUANTITY SELECTOR */
form {
  width: 300px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20px;
}

.value-button-left {
  display: inline-block;
  margin: 0px;
  width: 40px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
  padding: 3px 0px 3px 3px;
  border-radius: 20px 0px 0px 20px;
  user-select: none;
  color: #fff;
  font-size: 25px;
  font-weight: bold;
}

.value-button-right {
  display: inline-block;
  margin: 0px;
  width: 40px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
  padding: 3px 3px 3px 0px;
  border-radius: 0px 20px 20px 0px;
  user-select: none;
  color: #fff;
  font-size: 25px;
  font-weight: bold;
}

.value-button:hover {
  cursor: pointer;
}

input#number {
  text-align: center;
  border: none;
  margin: 0px;
  width: 40px;
  height: 40px;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/*=====================================================================================
DEFAULT PORTAL STYLING with minor changes to accomadate ordering system
/*=====================================================================================*/
/* 
    sidebar: begin 
*/
div#sidebar-flat-dark {
  overflow-y: scroll;
  padding-bottom: 50px;
}

div#sidebar-flat-dark::-webkit-scrollbar {
  display: none;
}

#content {
  min-height: 100vh !important;
}

.main-sidebar {
  bottom: 0px;
}
/* 
    sidebar: end 
*/

@media screen and (min-height: 901px) {
  .main-sidebar {
    position: absolute !important;
  }
}

/* Padding left */
.p-l-0 {
  padding-left: 0px;
}

.p-l-5 {
  padding-left: 5px;
}

.p-l-10 {
  padding-left: 10px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-l-30 {
  padding-left: 30px;
}

.p-l-40 {
  padding-left: 40px;
}

.p-l-50 {
  padding-left: 50px;
}

.p-l-100 {
  padding-left: 100px;
}

/* Padding right */
.p-r-0 {
  padding-right: 0px;
}

.p-r-5 {
  padding-right: 5px;
}

.p-r-10 {
  padding-right: 10px;
}

.p-r-20 {
  padding-right: 20px;
}

.p-r-30 {
  padding-right: 30px;
}

.p-r-40 {
  padding-right: 40px;
}

.p-r-50 {
  padding-right: 50px;
}

.p-r-100 {
  padding-right: 100px;
}

/* Padding bottom */
.p-b-0 {
  padding-bottom: 0px;
}

.p-b-5 {
  padding-bottom: 5px;
}

.p-b-10 {
  padding-bottom: 10px;
}

.p-b-20 {
  padding-bottom: 20px;
}

.p-b-30 {
  padding-bottom: 30px;
}

.p-b-40 {
  padding-bottom: 40px;
}

.p-b-50 {
  padding-bottom: 50px;
}

.p-b-100 {
  padding-bottom: 100px;
}

/* Padding top */
.p-t-0 {
  padding-top: 0px;
}

.p-t-5 {
  padding-top: 5px;
}

.p-t-10 {
  padding-top: 10px;
}

.p-t-20 {
  padding-top: 20px;
}

.p-t-30 {
  padding-top: 30px;
}

.p-t-40 {
  padding-top: 40px;
}

.p-t-50 {
  padding-top: 50px;
}

.p-t-100 {
  padding-top: 100px;
}

.active {
  color: white;
}

/* MENU BANNER */
.menu-banner {
  min-height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.franchise-icon {
  font-size: 100px;
  height: 150px;
  border-radius: 50%;
  width: 150px;
  position: absolute;
  margin-top: 100px;
  margin-left: -75px;
  border: solid;
  padding-top: 20px;
}

div.content {
  text-align: center;
}

@media (max-width: 767px) {
  .logo {
    width: 100px;
    position: absolute;
    margin-top: 55px;
    margin-left: -50px;
  }

  .menu-banner {
    min-height: 210px;
  }

  .franchise-icon {
    margin-top: 30px;
  }

  .topnav #menuCart label {
    color: transparent;
  }
}

ul.messenger {
  z-index: 100000 !important;
}

@media (max-width: 767px) {
  ul.messenger {
    right: 12px !important;
    top: 20px !important;
    bottom: auto !important;
    max-width: 90%;
  }
}

/* Cart: begin */

#menuCartContainer .cartItemsContainer {
  display: none;
  position: fixed;
  right: 0;
  width: 40%;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #dadada;
  border-bottom-left-radius: 5px;
  max-height: 60%;
  overflow-y: scroll;
  overflow-x: hidden;
  box-shadow: 0px 5px 9px 0px #8b8b8b;
}

#menuCartContainer .cartItemsContainer > div {
  display: grid;
  grid-template-rows: 35px 35px !important;
  grid-template-columns: min-content;
  grid-template-columns: min-content;
  align-items: end;
  position: relative;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

#menuCartContainer .cartItemsContainer > div:first-child {
  margin-top: 0px;
}

#menuCartContainer .cartItemsContainer > div .img-container,
#menuCartContainer .cartItemsContainer > div .img {
  border: none;
  width: 70px;
  height: 70px;
  margin-right: 15px;
  grid-column: 1;
  grid-row: 1/3;
  text-align: center;
}

#menuCartContainer .cartItemsContainer > div .img-container img {
  max-width: 100%;
  max-height: 100%;
}

#menuCartContainer .cartItemsContainer > div h5 {
  margin: 0px !important;
  font-weight: bold;
  grid-column: 2;
  grid-row: 1;
}

#menuCartContainer .cartItemsContainer > div .badge-container {
  text-align: right;
}

#menuCartContainer .cartItemsContainer > div .badge {
  background-color: #c30000;
  font-size: 10px;
  padding: 1px;
  padding-left: 3px;
  padding-right: 4px;
  width: fit-content;
  grid-column: 3;
  grid-row: 1;
}

#menuCartContainer .cartItemsContainer > div small {
  color: #8a8a8a;
  grid-column: 2;
  grid-row: 2;
  font-size: 85%;
}

#menuCartContainer .cartItemsContainer > div h5 span {
  float: right;
}

#menuCartContainer .cartItemsContainer > div h5 span.remove-item:hover {
  cursor: pointer;
}

#menuCartContainer .cartItemsContainer > div h6 {
  text-align: right;
  font-weight: bold;
  margin: 0px !important;
  grid-column: 3;
  grid-row: 2;
}

#menuCartContainer .cartItemsContainer > div form {
  margin-bottom: 0px;
}

#menuCartContainer .cartItemsContainer .cartTotal {
  display: inline-block;
}

#menuCartContainer .cartItemsContainer .viewCart {
  display: inline-block;
  text-align: right;
}

#menuCartContainer .cartItemsContainer .viewCart a {
  border-color: transparent !important;
}

@media screen and (max-width: 901px) {
  #menuCartContainer .cartItemsContainer {
    width: 100%;
    padding: 10px;
    border-radius: 0px;
  }

  #menuCartContainer .cartItemsContainer > div {
    padding-top: 10px;
  }

  #menuCartContainer .cartItemsContainer .viewCart {
    text-align: center;
  }
}
/* Cart: end */

/* Payment: end */
form.payment-result-form {
  min-height: 250px;
}
/* Payment: end */

.col-xs-12 {
  width: 100% !important;
}
.col-xs-11 {
  width: 91.66666667% !important;
}
.col-xs-10 {
  width: 83.33333333% !important;
}
.col-xs-9 {
  width: 75% !important;
}
.col-xs-8 {
  width: 66.66666667% !important;
}
.col-xs-7 {
  width: 58.33333333% !important;
}
.col-xs-6 {
  width: 50% !important;
}
.col-xs-5 {
  width: 41.66666667% !important;
}
.col-xs-4 {
  width: 33.33333333% !important;
}
.col-xs-3 {
  width: 25% !important;
}
.col-xs-2 {
  width: 16.66666667% !important;
}
.col-xs-1 {
  width: 8.33333333% !important;
}
h1,
.h1 {
  font-size: 36px !important;
}
h2,
.h2 {
  font-size: 30px !important;
}
h3,
.h3 {
  font-size: 24px !important;
}
h4,
.h4 {
  font-size: 18px !important;
}
h5,
.h5 {
  font-size: 14px !important;
}
h6,
.h6 {
  font-size: 12px !important;
}
</style>
